import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { Button } from '../ui/Button';
import { Heading, Text } from '../ui/Typography';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="text-9xl font-bold text-accent-500 mb-4">404</div>
          <Heading level={1} className="mb-3">
            Page Not Found
          </Heading>
          <Text size="lg" className="text-text-secondary">
            Oops! The page you're looking for doesn't exist or has been moved.
          </Text>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          
          <Button
            onClick={() => navigate('/dashboard')}
            variant="default"
            className="flex items-center justify-center gap-2"
          >
            <Home className="w-4 h-4" />
            Go to Dashboard
          </Button>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <div className="flex items-center justify-center gap-2 text-text-tertiary mb-3">
            <Search className="w-4 h-4" />
            <Text size="sm">Looking for something specific?</Text>
          </div>
          <div className="flex flex-wrap justify-center gap-2">
            <Button
              onClick={() => navigate('/agents')}
              variant="ghost"
              size="sm"
            >
              Agents
            </Button>
            <Button
              onClick={() => navigate('/projects')}
              variant="ghost"
              size="sm"
            >
              Projects
            </Button>
            <Button
              onClick={() => navigate('/reports')}
              variant="ghost"
              size="sm"
            >
              Reports
            </Button>
            <Button
              onClick={() => navigate('/integrations')}
              variant="ghost"
              size="sm"
            >
              Integrations
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

